var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"meeting_agree_content"},[_c('div',{staticClass:"meeting_agree_content_main",domProps:{"innerHTML":_vm._s(_vm.detail || '')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }